import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttachment1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 40,
		height: 40,
		rx: 7,
		fill: "#FF9F48"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.4165 20.3703C15.3246 19.2785 15.3246 17.5083 16.4165 16.4165C17.5083 15.3246 19.2785 15.3246 20.3703 16.4165L26.5835 22.6296C27.6753 23.7215 27.6753 25.4917 26.5835 26.5835C25.4917 27.6753 23.7215 27.6753 22.6296 26.5835L19.3819 23.3357C18.9919 22.9458 18.9919 22.3136 19.3819 21.9237C19.7718 21.5337 20.404 21.5337 20.7939 21.9237L23.7594 24.889C24.0713 25.201 24.577 25.201 24.889 24.889C25.201 24.577 25.201 24.0713 24.889 23.7594L21.9237 20.7939C20.9098 19.7801 19.266 19.7801 18.2522 20.7939C17.2383 21.8078 17.2383 23.4515 18.2522 24.4654L21.5 27.7132C23.2157 29.4289 25.9975 29.4289 27.7132 27.7132C29.4289 25.9975 29.4289 23.2157 27.7132 21.5L21.5 15.2868C19.7843 13.5711 17.0025 13.5711 15.2868 15.2868C13.5711 17.0025 13.5711 19.7843 15.2868 21.5L15.5692 21.7824C15.8811 22.0944 16.3869 22.0944 16.6989 21.7824C17.0108 21.4705 17.0108 20.9647 16.6989 20.6528L16.4165 20.3703Z",
		fill: "white"
	})]
});
export default SvgAttachment1;
